import AdvanceAvatarInline from './AdvanceAvatarInline';

export default AdvanceAvatarInline;
